// Types mirroring packages/contracts/studio-api.yaml. The OpenAPI file is the source of truth;
// these are kept in lockstep with it (no hand-maintained duplicate domain models elsewhere).
// States on which the scheduler will NOT place new work — mirror of domain CapacityState.Schedulable.
export const BLOCKED_CAPACITY_STATES = [
    'EXHAUSTED',
    'AUTH_REQUIRED',
    'RUNTIME_UNAVAILABLE',
    'STALE',
];
// Ordered board columns (BLOCKED is a transient overlay column) — mirror of domain.WorkStateColumns.
export const WORK_STATE_COLUMNS = [
    'BACKLOG',
    'READY',
    'IN_PROGRESS',
    'BLOCKED',
    'IN_REVIEW',
    'QA',
    'READY_FOR_RELEASE',
    'DONE',
];
